module.exports = __webpack_public_path__ + "static/sales-fd8bda450fc5e05d45fcb9c0f2116cf4.jpeg";